import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionExpiredService {
  private sessionExpiredSource = new Subject<void>();
  sessionExpired$ = this.sessionExpiredSource.asObservable();

  notifySessionExpired(): void {
    this.sessionExpiredSource.next();
  }
}
